import type { NPCConfig } from '@/entities';

const config: NPCConfig[] = [
  {
    x: 880,
    y: 1170,
    name: 'Elsa',
    color: 0x9932cc,
    spriteImage: 'assets/sprite/sprite_elsa.png',
    flipSprite : true,
    repeatable : true,
    dialogTree: {
      startDialogId: 'elsa_1',
      nodes: {
        elsa_1: {
          id: 'elsa_1',
          speaker: 'Elsa',
          text: `Banyak kenangan baik di tempat ini. Walau hanya sebentar`,
          characterImage: '/assets/character/v2/elsa.png',
          backgroundImage: '/assets/backdrop/desa.png',
          nextDialogId : "elsa_2",
        },
        elsa_2: {
          id: 'elsa_1',
          speaker: 'Elsa',
          text: `Tetapi, sudah saatnya aku pulang`,
          characterImage: '/assets/character/v2/elsa.png',
          backgroundImage: '/assets/backdrop/desa.png',
          storyAction: { type: 'nextDay', value: 0 },
        }
      },
    },
  },
  {
    x: 1000,
    y: 1230,
    name: '',
    color: 0x9932cc,
    spriteImage: 'assets/sprite/nada.png',
    flipSprite : true,
    repeatable : true,
    dialogTree: {
      startDialogId: 'elsa_1',
      triggerOnCollision: true,
      nodes: {
        elsa_1: {
          id: 'elsa_1',
          speaker: 'Elsa',
          text: `Ayo Yan! Cepat!`,
          characterImage: '/assets/character/v2/elsa.png',
          backgroundImage: '/assets/backdrop/desa.png',
          nextDialogId : "elsa_2",
        },
        elsa_2: {
          id: 'elsa_1',
          speaker: 'Elsa',
          text: `Kamu dengar itu?`,
          characterImage: '/assets/character/v2/elsa.png',
          backgroundImage: '/assets/backdrop/desa.png',
          nextDialogId : "elsa_3",
          //todo sfx rustling sound
        },
        elsa_3: {
          id: 'elsa_1',
          speaker: 'Elsa',
          text: `Sepertinya suara itu mendekat`,
          characterImage: '/assets/character/v2/elsa.png',
          backgroundImage: '/assets/backdrop/desa.png',
          nextDialogId : "elsa_4",
          //todo sfx rustling sound louder
        },
        elsa_4: {
          id: 'elsa_1',
          speaker: 'Elsa',
          text: `Aaaaa!`,
          characterImage: '/assets/character/v2/elsa.png',
          backgroundImage: '/assets/backdrop/desa.png',
          nextDialogId : "elsa_5",
          //todo sfx rustling sound
        },
        elsa_5: {
          id: 'elsa_1',
          speaker: 'Elsa',
          text: ``,
          characterImage: '/assets/character/v2/elsa.png',
          backgroundImage: '/assets/backdrop/desa.png',//TODO cutscene elsa mati
          nextDialogId : "elsa_6",
        },
        elsa_6: {
          id: 'elsa_1',
          speaker: 'Elsa',
          text: ``,
          characterImage: '/assets/character/v2/elsa.png',
          backgroundImage: '/assets/backdrop/desa.png',
          isGameOver : true,
        },
      },
    },
  },
];

export default config;
